'use client';
import { MouseEvent } from 'react';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import BaseButtonWithProgress from '@components/BaseButtonWithProgress';
import { classNames } from '@repo/ui/src/utils/classNames';
import { CTAButtonProps } from '@repo/ui/src/types';

interface Props {
  buttonProps?: CTAButtonProps;
  onClickAddToCart: (e: MouseEvent<HTMLElement>) => void;
  buttonProcessing?: boolean;
  processingText?: string;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

const AddToCartButton = ({
  buttonProps,
  buttonProcessing = false,
  processingText,
  onClickAddToCart,
  className,
  disabled,
  children,
}: Props) => {
  const { t } = useTranslation();

  return (
    <BaseButtonWithProgress
      {...buttonProps}
      processing={buttonProcessing}
      processingText={processingText}
      onClick={(e: MouseEvent<HTMLElement>) => {
        e.preventDefault();
        onClickAddToCart(e);
      }}
      className={classNames(className, buttonProps?.className, 'tw-relative')}
      disabled={disabled ?? buttonProps?.disabled}
    >
      {t('productDetailPageContent.addToCartText', undefined, { default: 'Add to Cart' })}
      {children}
    </BaseButtonWithProgress>
  );
};

export default AddToCartButton;
